<template>
  <div class="tw-bg-white tw-shadow-md tw-rounded-xl tw-p-6 tw-border tw-border-amber-200 tw-bg-amber-50/40">
    <div class="tw-flex tw-items-start tw-space-x-3 tw-mb-3">
      <div class="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-full tw-bg-amber-100">
        <svg
          class="tw-h-5 tw-w-5 tw-text-amber-700"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
      <div>
        <h3 class="tw-text-base tw-font-semibold tw-text-slate-900">
          Sign-off not available
        </h3>
        <p class="tw-mt-1 tw-text-sm tw-text-slate-700">
          {{ message }}
        </p>
      </div>
    </div>

    <p class="tw-text-xs tw-text-slate-600">
      If you have any questions about this quote, please reply to your quote email or contact our team.
    </p>
  </div>
</template>

<script>
export default {
  name: 'CheckoutLockedCard',
  props: {
    message: {
      type: String,
      default: 'This quote cannot currently be signed-off. Please contact our team for more information.'
    }
  }
}
</script>
